// NOTE: NSAI-5711 — a formatted numeric expression such as "589,494 / 1,000"
// carries no strong directional character of its own: the digit runs are weak
// and the "/" between them is neutral. Dropped into an RTL paragraph, the
// Unicode bidirectional algorithm therefore lays the two runs out right-to-left
// and an Arabic reader sees "1,000 / 589,494" — used and limit transposed, on
// the one figure the line exists to communicate.
//
// Isolating each number on its own does NOT fix it: two isolates separated by a
// neutral still order right-to-left at the paragraph level. The pair has to be
// isolated as a single left-to-right run, which is what LRI ... PDI does.

// NOTE: U+2066 LEFT-TO-RIGHT ISOLATE — opens a run laid out left-to-right whose
// ordering cannot interact with the surrounding text.
const LEFT_TO_RIGHT_ISOLATE = "⁦";

// NOTE: U+2069 POP DIRECTIONAL ISOLATE — closes the innermost open isolate.
const POP_DIRECTIONAL_ISOLATE = "⁩";

// NOTE: Keeps an already-formatted value in logical left-to-right order
// regardless of the surrounding paragraph direction. A no-op under LTR locales
// (the isolate characters are invisible and the ordering is unchanged), so
// callers can apply it unconditionally instead of branching on locale.
//
// Both apps need this: web could lean on `dir="ltr"` / `<bdi>`, but React
// Native `Text` has no such attribute, so the Unicode form is the only spelling
// that works on web and mobile alike.
export const isolateLtr = (value: string): string =>
  `${LEFT_TO_RIGHT_ISOLATE}${value}${POP_DIRECTIONAL_ISOLATE}`;
